import React, { useState } from 'react';
import './Login.css';

/** Full admin dashboard access (same role). Passwords live in the client bundle — use env-backed auth when possible. */
const ADMIN_ACCOUNTS = [
  { login: 'report', password: 'report123' },
  { login: 'gurmeetnaroola@gmail.com', password: 'ifec2026', settingsAccess: false },
  { login: 'sumeet@ifec.co.in', password: 'password@123', settingsAccess: false },
  { login: 'minnijaitly@gmail.com', password: 'password@123', settingsAccess: false },
  { login: 'amin@ifec.co.in', password: 'password@123', settingsAccess: false },
  { login: 'hsingh@ifec.co.in', password: 'password@123', settingsAccess: false },
  { login: 'accounts@ifec.co.in', password: 'password@123', settingsAccess: false },
];

function findAdminAccount(username, password) {
  const u = username.trim().toLowerCase();
  const p = password.trim();
  return ADMIN_ACCOUNTS.find(
    (a) => a.login.toLowerCase() === u && a.password === p
  );
}

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Trim whitespace from inputs
    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();

    // Simulate login delay
    setTimeout(() => {
      const adminMatch = findAdminAccount(trimmedUsername, trimmedPassword);
      if (adminMatch) {
        console.log('✅ Admin login successful!');
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('username', adminMatch.login);
        localStorage.setItem('userRole', 'admin');
        localStorage.setItem(
          'settingsAccess',
          adminMatch.settingsAccess === false ? 'false' : 'true'
        );
        onLogin();
      } else if (trimmedUsername === 'hradmin' && trimmedPassword === 'hr345') {
        console.log('✅ HR Admin login successful!');
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('username', trimmedUsername);
        localStorage.setItem('userRole', 'hradmin');
        localStorage.removeItem('settingsAccess');
        onLogin();
      } else {
        setError('Invalid username or password. Please try again.');
        console.log('❌ Login failed for:', trimmedUsername);
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo-section">
            <h1>IFEC Report</h1>
          </div>
          <p className="login-subtitle">Daily Production Management System</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username or email</label>
            <div className="input-wrapper">
              <span className="input-icon">👤</span>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Username or email"
                required
                autoComplete="username"
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <span className="input-icon">🔒</span>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                autoComplete="current-password"
                disabled={loading}
              />
            </div>
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span>
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className={`login-button ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Signing In...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>

      <div className="login-background">
        <div className="bg-shape shape-1"></div>
        <div className="bg-shape shape-2"></div>
        <div className="bg-shape shape-3"></div>
      </div>
    </div>
  );
};

export default Login;

